// IMPORTANT: this enum is in its own file because it is used in cross-concerning parts of the app, and during testing
// Jest eagerly imports a tree of dependencies from the file this enum was kept in previously ('router/states/index.ts),
// causing fragility and unnecessarily long tests setup.
export enum RouterStates {
  loginCallback = 'login-callback',
  home = 'home',
  databases = 'databases',
  jobs = 'jobs',
  jobRequests = 'job-requests',
  diagnostics = 'diagnostics'
}
